<template>
  <button
    type="button"
    class="button"
    @click.stop="toggle"
  >
    <HamburgueMenuSVG />
  </button>
</template>

<script>
  import { mapActions } from 'vuex'
  import HamburgueMenuSVG from '@/components/svg/HamburgueMenuSVG'

  export default {
    components: {
      HamburgueMenuSVG,
    },

    methods: {
      ...mapActions('slideSidebar', [
        'slideSidebarToggle',
      ]),

      toggle () {
        this.slideSidebarToggle({ name: 'MenuSidebar', direction: 'left' })
      },
    },
  }
</script>


<style scoped lang="scss">
  .button {
    display: flex;
    align-items: center;
    margin-right: 10px;
    border-right: 1px solid rgba(#000, .2);
    padding-right: 10px;

    svg {
      margin-right: 5px;
      width: 25px;
    }

    span {
      font-size: 13px;
      font-weight: 700;
      text-transform: uppercase;
    }

    span, svg {color: rgba(#000, .75); fill: rgba(#000, .75)}
  }
</style>